import React, { useContext } from "react";
import { FlinkContext } from "../../../../context/FlinkContext";
import Title from "../../../Title/Title";
import OverviewCard from "../OverviewCard";
import overviewCards from "../OverviewDummy";
import "./Owerview.scss";

export default function Overview() {
  const overviewData = useContext(FlinkContext);

  return (
    <div className="Overview Flink-container">
      <Title title="OVERVIEW" />
      {overviewData && (
        <div className="Overview__box">
          <div>
            <OverviewCard
              config={overviewCards.gas}
              market={overviewData?.overview?.gas}
              scrollId="gas"
            />
          </div>
          <div>
            <OverviewCard
              config={overviewCards.power}
              market={overviewData?.overview?.power}
              scrollId="power"
            />
          </div>
          <div>
            <OverviewCard
              config={overviewCards.carbon}
              market={overviewData?.overview?.carbon}
              scrollId="carbon"
            />
          </div>
          <div>
            <OverviewCard
              config={overviewCards.currency}
              market={overviewData?.overview?.currency}
              scrollId="currency"
            />
          </div>
        </div>
      )}
    </div>
  );
}
